module.exports = __webpack_public_path__ + "static/media/good-for-me-or-good-for-cavity-monsters.9ba8e99.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/good-for-me-or-good-for-cavity-monsters.mp3
// module id = NKZU
// module chunks = 0